import { traceService } from './traceService';

export function traceLog(params: { traceId?: string; type: string; data: any; metadata?: any }) {
  // Remove unreliable caller parsing; forward data/metadata unchanged
  traceService.log({
    traceId: params.traceId || (params as any).data?.traceId,
    type: params.type,
    data: params.data,
    metadata: params.metadata,
  });
}


